<div class="conference-hero no-print">
    <div class="conference-hero-titulo">
        <div class="conference-hero-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 12l2 2 4-4"></path>
                <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9c1.5 0 2.91.37 4.15 1.02"></path>
                <path d="M21 5L12 14l-3-3"></path>
            </svg>
        </div>
        <div>
            <h1>Conferencia Cliente</h1>
            <p>Relatorio de entrega e conferencia por venda</p>
        </div>
    </div>

    <button type="button" class="conference-action" [disabled]="!conferencia" (click)="abrirModalImpressao()">
        Imprimir
    </button>
</div>

<div class="conference-modal-backdrop no-print" *ngIf="modalImpressaoAberto" (click)="cancelarImpressao()">
    <div class="conference-print-modal" (click)="$event.stopPropagation()">
        <div class="conference-print-modal-header">
            <div>
                <h2>Imprimir conferencia</h2>
                <p>Selecione o modelo de impressao.</p>
            </div>
        </div>

        <div class="conference-print-options">
            <label [class.active]="tipoImpressao === 'completa'">
                <input type="radio" name="tipoImpressao" value="completa" [(ngModel)]="tipoImpressao">
                <span>Completa</span>
            </label>

            <label [class.active]="tipoImpressao === 'simplificada'">
                <input type="radio" name="tipoImpressao" value="simplificada" [(ngModel)]="tipoImpressao">
                <span>Simplificada</span>
            </label>

            <label [class.active]="tipoImpressao === 'ambas'">
                <input type="radio" name="tipoImpressao" value="ambas" [(ngModel)]="tipoImpressao">
                <span>Completa e Simplificada</span>
            </label>
        </div>

        <div class="conference-print-modal-actions">
            <button type="button" class="conference-modal-cancel" (click)="cancelarImpressao()">Cancelar</button>
            <button type="button" class="conference-modal-confirm" (click)="confirmarImpressao()">Confirmar</button>
        </div>
    </div>
</div>

<section class="quick-sale-search no-print" *ngIf="!conferencia">
    <div class="quick-sale-title">Buscar venda para conferencia</div>

    <div class="quick-sale-filters">
        <div class="quick-sale-field" #clienteBuscaField>
            <input
                    type="text"
                    autocomplete="off"
                    placeholder="Digite o CNPJ ou Nome do cliente..."
                    [(ngModel)]="buscaClienteTexto"
                      (input)="agendarBuscaClientes()"
                      (focus)="abrirDropdownClientes()">

            <div class="quick-sale-dropdown" *ngIf="dropdownClientesAberto" [ngStyle]="dropdownClienteStyle">
                <button
                        type="button"
                        class="quick-sale-option"
                        *ngFor="let cliente of clientesBusca"
                        (click)="selecionarCliente(cliente)">
                    {{ labelCliente(cliente) }}
                </button>

                <div class="quick-sale-empty" *ngIf="!clientesBusca.length && mensagemBusca">
                    {{ mensagemBusca }}
                </div>
            </div>
        </div>

        <label class="quick-sale-date">
            <span>Dt. inicial</span>
            <input type="date" [(ngModel)]="buscaDataInicial">
        </label>

        <label class="quick-sale-date">
            <span>Dt. final</span>
            <input type="date" [(ngModel)]="buscaDataFinal">
        </label>

        <button type="button" class="quick-sale-search-button" (click)="buscarFiltro()">
            Buscar
        </button>
    </div>

    <div class="conference-selected quick-sale-selected" *ngIf="clienteSelecionado">
        <strong>{{ labelCliente(clienteSelecionado) }}</strong>
        <span>Selecione uma venda para gerar a conferencia.</span>
    </div>

    <div class="conference-notes quick-sale-notes" *ngIf="vendasCliente.length">
        <div class="conference-note quick-sale-note quick-sale-note-header conferencia-note" aria-hidden="true">
            <span>No UNICO</span>
            <span>VENDA</span>
            <span>DATA</span>
            <span>STATUS</span>
            <span>VALOR R$</span>
        </div>

        <button type="button" class="conference-note quick-sale-note conferencia-note" *ngFor="let venda of vendasCliente" (click)="selecionarVenda(venda)">
            <span>{{ valor(venda, 'NUNOTA') || valor(venda, 'nunota') }}</span>
            <span>{{ numeroVenda(venda) }}</span>
            <span>{{ valor(venda, 'DTNEG') }}</span>
            <span>{{ valor(venda, 'STATUS') || valor(venda, 'STATUSNOTA') || '-' }}</span>
            <span>{{ valorVenda(venda) }}</span>
        </button>
    </div>

    <div class="conference-empty quick-sale-empty" *ngIf="mensagemBusca && !dropdownClientesAberto">
        {{ mensagemBusca }}
    </div>
</section>

<div class="conference-return-row no-print" *ngIf="conferencia">
    <div class="print-zoom-controls">
        <button type="button" class="print-zoom-button" (click)="zoomConferencia('+')" title="Aumentar zoom">+</button>
        <button type="button" class="print-zoom-button" (click)="zoomConferencia('-')" title="Diminuir zoom">-</button>
        <button type="button" class="print-zoom-button print-zoom-toggle" (click)="alternarZoomConferencia()" [title]="conferenciaZoomAtual >= 1.6 ? 'Voltar ao zoom padrao' : 'Aplicar zoom maximo'">
            <lucide-angular [img]="conferenciaZoomAtual >= 1.6 ? ZoomOut : ZoomIn" size="18"></lucide-angular>
        </button>
    </div>

    <button type="button" class="print-return-button" (click)="voltarParaBusca()">Voltar</button>
</div>

<main class="conference-page" *ngIf="conferencia" [ngStyle]="estiloZoomConferencia()">
    <header class="conference-header">
        <div class="brand-block">
            <img src="assets/logo_global.png" alt="Global Parts">
            <span>GLOBAL PARTS LTDA</span>
        </div>

        <div class="title-block">
            <strong>ENTREGA - CONFERENCIA DE CLIENTE</strong>
            <span>{{ numeroVenda(conferencia) }}</span>
        </div>

        <div class="right-identification">
            <strong>{{ valor(conferencia, 'NUNOTA') }}</strong>
            <span class="barcode"></span>
            <small>Separar imediatamente: NAO</small>
        </div>
    </header>

    <section class="info-card">
        <div><span>Emissao:</span><strong>{{ valor(conferencia, 'DTNEG') || valor(conferencia, 'DTATUAL') }}</strong></div>
        <div class="info-client"><span>Cliente:</span><strong>{{ valor(conferencia, 'NOMEPARC') }}</strong></div>
        <div><span>Tipo:</span><strong>{{ tipoVenda(conferencia) }}</strong></div>
        <div><span>Status:</span><strong>{{ statusVenda(conferencia) }}</strong></div>

        <div class="info-address"><span>Endereco:</span><strong>{{ enderecoFaturamento(conferencia) }}</strong></div>
        <div><span>CPF/CNPJ:</span><strong>{{ valor(conferencia, 'CNPJ') }}</strong></div>
        <div><span>Vendedor:</span><strong>{{ valor(conferencia, 'VENDEDOR') || '-' }}</strong></div>

        <div><span>Bairro:</span><strong>{{ bairroFaturamento(conferencia) }}</strong></div>
        <div><span>Cidade:</span><strong>{{ cidadeUfFaturamento(conferencia) }}</strong></div>
        <div><span>CEP:</span><strong>{{ cepFaturamento(conferencia) }}</strong></div>
        <div><span>Email:</span><strong>{{ emailFaturamento(conferencia) }}</strong></div>
        <div><span>Fone(s):</span><strong>{{ fonesFaturamento(conferencia) }}</strong></div>
    </section>

    <section class="delivery-info-card">
        <div class="delivery-top"><span>Transportadora:</span><strong>{{ transportadora(conferencia) }}</strong></div>
        <div class="delivery-top"><span>T. Frete:</span><strong>{{ tipoFrete(conferencia) }}</strong></div>
        <div class="delivery-top"><span>Envio:</span><strong>{{ envio(conferencia) }}</strong></div>
        <div class="delivery-top"><span>Vol.:</span><strong>{{ volume(conferencia) }}</strong></div>
        <div class="delivery-top"><span>Prefixo:</span><strong>{{ prefixo(conferencia) }}</strong></div>
        <div class="delivery-divider"></div>
        <div class="delivery-name"><span>Cliente de Entrega:</span><strong>{{ clienteEntrega(conferencia) }}</strong></div>
        <div class="delivery-doc"><span>CPF/CNPJ:</span><strong>{{ documentoEntrega(conferencia) }}</strong></div>
        <div class="delivery-email"><span>Email:</span><strong>{{ emailEntrega(conferencia) }}</strong></div>
        <div class="delivery-address"><span>Endereco de Entrega:</span><strong>{{ enderecoEntregaLinha(conferencia) }}</strong></div>
        <div class="delivery-phone"><span>Fone(s):</span><strong>{{ fonesEntrega(conferencia) }}</strong></div>
        <div class="delivery-neighborhood"><span>Bairro:</span><strong>{{ bairroEntrega(conferencia) }}</strong></div>
        <div class="delivery-city"><span>Cidade:</span><strong>{{ cidadeUfEntrega(conferencia) }}</strong></div>
        <div class="delivery-cep"><span>CEP:</span><strong>{{ cepEntrega(conferencia) }}</strong></div>
    </section>

    <section class="conference-observation" style="display: none !important;">
        <span>Observação:</span>
        <strong>{{ observacao(conferencia) || '-' }}</strong>
    </section>

    <section class="table-title">Lista de Pecas / Produtos</section>

    <section class="conference-table">
        <div class="conf-head">
            <span>Ord</span>
            <span>Part Number</span>
            <span>Descricao</span>
            <span>Quant.</span>
            <span>Dev.</span>
            <span>Fabricante</span>
            <span>Saida</span>
            <span>Und</span>
            <span>Entrega</span>
        </div>

        <article class="conf-item" *ngFor="let item of itens; let i = index" [class.alt]="i % 2 === 1">
            <div class="ord-cell" style="text-align: center;">
                <strong>{{ i + 1 }}</strong>
                <span>&nbsp;</span>
            </div>

            <div class="part-cell">
                <strong>{{ itemPartNumber(item) }}</strong>
                <span>CD: {{ itemCondicao(item) }}</span>
            </div>

            <div class="desc-cell">
                <strong>{{ itemDescricao(item) }}</strong>
                <span *ngIf="itemSerial(item)?.trim()">Serial: {{ itemSerial(item) }}</span>
            </div>

            <div>
                <strong>{{ itemQtd(item) }}</strong>
                <span>&nbsp;</span>
            </div>

            <div>
                <strong>0,00</strong>
                <span>&nbsp;</span>
            </div>

            <div>
                <strong>{{ itemFabricante(item) }}</strong>
                <span>&nbsp;</span>
            </div>

            <div>
                <strong>{{ itemSaida(item) }}</strong>
                <span>&nbsp;</span>
            </div>

            <div>
                <strong>{{ itemUnd(item) }}</strong>
                <span>&nbsp;</span>
            </div>

            <div class="delivery-cell" style="text-align: center !important;">
                <span>( ) Total &nbsp;&nbsp; ( ) Nenhuma &nbsp;&nbsp; ( ) Parcial /Qtde: _________</span>
                <span>Ass: _________________________________________________</span>
            </div>
        </article>
    </section>

    <footer class="conference-footer">
        <span>Entrega:</span>
        <span>Observacao:<i style="min-width: 400px"></i>{{ observacao(conferencia) }}</span>
        <span>Ass:<i></i></span>
        <span>CPF:<i></i></span>
    </footer>

    <footer class="conference-doc-footer">
        <div class="conference-footer-bottom">
            <div class="conference-footer-codes">
                {{ codigoEmpresa(conferencia) }}<br>
                {{ usuarioAtual(conferencia) }}
            </div>

            <div class="conference-footer-center">
                AV. DOS INDIOS No 352, QD.124, LT. 38 - SANTA GENOVEVA - CEP 74.672-450 - GOIANIA - GO
                <br>
                Fone(s): + (62)3207-1414 + (62)3207-1413 - www.globalp.com.br - email: fabio&#64;globalp.com.br
            </div>

            <div class="conference-footer-page">
                Pag: 1 / 1
                <br>
                {{ dataAtual() }} {{ horaAtual() }}
            </div>
        </div>
    </footer>
</main>

<main class="conference-simple-page" *ngIf="conferencia">
    <header class="simple-header">
        <div class="simple-brand-block">
            <img src="assets/logo_global.png" alt="Global Parts">
            <span>GLOBAL PARTS LTDA</span>
        </div>

        <div class="simple-title-block">
            <strong>ENTREGA - CONFERENCIA DE CLIENTE</strong>
            <span>{{ numeroVenda(conferencia) }}</span>
        </div>

        <div class="simple-qr-block">
            <img [src]="qrCodePublicoPedido(conferencia)" alt="QR Code do pedido">
            <span>Acompanhar pedido</span>
        </div>
    </header>

    <section class="simple-meta-card">
        <div><span>Emissao:</span><strong>{{ valor(conferencia, 'DTNEG') || valor(conferencia, 'DTATUAL') }}</strong></div>
        <div><span>Cliente:</span><strong>{{ valor(conferencia, 'NOMEPARC') }}</strong></div>
        <div><span>CPF/CNPJ:</span><strong>{{ valor(conferencia, 'CNPJ') }}</strong></div>
        <div><span>Venda:</span><strong>{{ valor(conferencia, 'NUNOTA') }}</strong></div>
    </section>

    <section class="simple-products-grid">
        <ng-container *ngFor="let coluna of itensSimplificadosColunas()">
            <table class="simple-products-table" *ngIf="coluna.length">
                <thead>
                    <tr>
                        <th>QTD</th>
                        <th>P/N</th>
                        <th>Descricao</th>
                        <th>CD</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of coluna">
                        <td>{{ itemQtdSimplificada(item) }}</td>
                        <td>{{ itemPartNumber(item) }}</td>
                        <td>{{ itemDescricao(item) }}</td>
                        <td>{{ itemCondicao(item) }}</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    </section>

    <footer class="simple-footer">
        AV. DOS INDIOS No 352, QD.124, LT. 38 - SANTA GENOVEVA - CEP 74.672-450 - GOIANIA - GO
        <br>
        Fone(s): + (62)3207-1414 + (62)3207-1413 - www.globalp.com.br - email: fabio&#64;globalp.com.br
    </footer>
</main>

<div class="loading no-print" *ngIf="carregando()"><app-loading-indicator></app-loading-indicator> Carregando conferencia...</div>
